"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  height: 0;\n  padding-top: ", "%;\n  position: relative;\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AspectRatioBox = void 0;

var styledTypes_1 = require("./styledTypes");

exports.AspectRatioBox = styledTypes_1.styled.div(_templateObject(), function (props) {
  return props.ratio * 100;
});